




































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import NavBar from '../../components/NavBar.vue';
import TabBar from '../../components/TabBar.vue';
import Button from '../../components/Button.vue';
import Translation from '@/components/i18n/Translation.vue';
import BookingCommuneSelect from '@/views/taxcard/booking/BookingCommuneSelect.vue';
import AddBIObjectButton from '@/views/taxcard/booking/AddBIObjectButton.vue';
import BookingProceedButton from '@/views/taxcard/booking/BookingProceedButton.vue';
import Booking from '@/types/taxcard/Booking';
import BIObject from '@/types/taxcard/BIObject';
import GuestType, { GuestTypesEnum } from '@/types/taxcard/GuestType';
import BookingItems from '@/views/taxcard/booking/BookingItems.vue';
import AdditionalMandatoryField from '@/types/validation/AdditionalMandatoryField';
import { Getter, namespace } from 'vuex-class';
import CommuneProjection from '@/types/projections/CommuneProjection';
import BookingPriceProjection from '@/types/projections/BookingPriceProjection';
import MinimalCommuneProjection from '@/types/projections/MinimalCommuneProjection';
import Loader from '@/components/Loader.vue';
import moment from 'moment';
import AnnualCandidateProjection from '@/types/projections/AnnualCandidateProjection';
import i18next from 'i18next';
import NewTranslation from '@/components/i18n/NewTranslation.vue';
import AccommodationQRScanner from '@/components/qr/accommodation/AccommodationQRScanner.vue';
import AccommodationProjection from '@/types/projections/AccommodationProjection';
import { getMandatoryFieldsToValidate } from '../utils/elementsValidationAndVisualization';
import AdditionalGuestTypeFields from '@/types/taxcard/AdditionalGuestTypeFields';
import BIObjectData from '@/types/taxcard/BIObjectData';
import { findGuestTypeOptionRadioValue } from './booking/GuesttypeSelectorFunctions';
import CommuneGuestTypeOption from '@/types/taxcard/CommuneGuestTypeOption';
import { momentEndDay, momentStartDay } from '../utils/timeCalculations';

const BookingModule = namespace('booking');

@Component({
  components: {
    AccommodationQRScanner,
    NewTranslation,
    BookingItems,
    NavBar,
    TabBar,
    Button,
    Translation,
    BookingCommuneSelect,
    AddBIObjectButton,
    BookingProceedButton,
    Loader,
  },
})
export default class BookingView extends Vue {
  @Prop(Array)
  private lang!: Array<{ [key: string]: string }>;

  private booking: Booking = new Booking(0);

  private bIObjectCount: number = 0;

  private proceedIsLoading: boolean = false;
  
  private canUpdatePrices: boolean = true;

  private openBIObjectIndex: number | null = null;

  @BookingModule.Action('fetchCommunes')
  public fetchCommunes!: any;

  @BookingModule.Action('fetchCommune')
  public fetchCommune!: any;

  @BookingModule.Action('fetchBookingPrice')
  public fetchBookingPrice!: any;

  @BookingModule.Action('donationRequest')
  public donationRequest!: any;

  @BookingModule.Action('bookingRequest')
  public bookingRequest!: any;

  @BookingModule.Getter('communes')
  public communes!: MinimalCommuneProjection[];

  @BookingModule.Mutation
  public setCurrentBooking!: any;

  @BookingModule.Mutation
  public setCurrentBookingToCheckoutView!: any;

  @BookingModule.Mutation
  public setCurrentPriceProjection!: any;

  @BookingModule.Mutation
  public setCurrentOrderId!: any;

  @BookingModule.Getter('currentBooking')
  public initialBooking!: Booking | null;

  @BookingModule.Getter('currentPriceProjection')
  public initialPriceProjection!: BookingPriceProjection | null;

  @Getter('loggedInUser')
  public isLoggedIn!: boolean;

  @BookingModule.Action('fetchAnnualCandidate')
  public fetchAnnualCandidate!: any;

  @Getter('manuallyDefinedSpecialConditions')
  public manuallyDefinedSpecialConditions!: any;

  public priceProjection: BookingPriceProjection = {} as any;

  public communeIsLoading: boolean = false;

  public communeNeedsReset: boolean = false;

  public priceProjectionIsLoading: boolean = false;

  public doPriceProjectionRetry: boolean = false;

  public commune: CommuneProjection | null = null;

  public communeGuestTypeOptions: CommuneGuestTypeOption[] = [];

  public toggleDiscountsLoading: boolean = false;

  private async created() {
    const initialBooking = this.initialBooking;
    this.canUpdatePrices = false;
    if (initialBooking) {
      this.$trackEvent('booking', 'entered', 'continue');
    } else {
      this.$trackEvent('booking', 'entered', 'fresh');
    }
    if (this.initialPriceProjection) {
      this.priceProjection = { ...this.initialPriceProjection };
    }
    await this.fetchCommunes();
    const communes = this.communes;

    let defaultGuestType: GuestType | null = null;
    let defaultSubGuestType: string = '';
    let defaultIsAnnual = false;
    let shouldLoadQueryParams = false;
    let defaultIsAnonymous: boolean | null = null;
    let hasGuestTypeQueryParams = false;
    let hasAnonymousQueryParam = false;

    if (communes && communes.length > 0) {
      this.booking = !initialBooking ? new Booking() : initialBooking;
      this.bIObjectCount = 1;
      this.openBIObjectIndex = 0;
      await this.loadAndSetCommune(parseInt(this.$route.params.communeId, 10));

      const communeWebConfig = this.commune && this.commune.webConfiguration;
      if (communeWebConfig) {
        defaultGuestType = communeWebConfig.defaultGuestType;
        defaultSubGuestType = communeWebConfig.defaultSubGuestType || '';
        defaultIsAnonymous = communeWebConfig.defaultIsAnonymous;
      }

      // Query params override the commune defaults only if the requested guest type option exists.
      const hasGuestTypeQueryParam = !!(this.$route.query && this.$route.query.guesttype);
      const hasSubGuestTypeQueryParam = !!(this.$route.query && this.$route.query.subGuestType);
      if (hasGuestTypeQueryParam || hasSubGuestTypeQueryParam) {
        const requestedGuestType = hasGuestTypeQueryParam ? String(this.$route.query.guesttype) : '';
        const requestedSubGuestType = hasSubGuestTypeQueryParam ? String(this.$route.query.subGuestType) : '';
        const isValidGuestType = requestedGuestType === GuestTypesEnum.day || requestedGuestType === GuestTypesEnum.overnight;
        const requestedOption = isValidGuestType
          ? this.findCommuneGuestTypeOption(requestedGuestType as GuestType, requestedSubGuestType)
          : undefined;

        if (requestedOption) {
          defaultGuestType = requestedOption.guestType;
          defaultSubGuestType = requestedOption.subGuestType;
          defaultIsAnnual = requestedOption.isAnnual;
          hasGuestTypeQueryParams = true;
        } else {
          console.warn(`Ignoring unsupported guest type query params '${requestedGuestType}#${requestedSubGuestType}'.`);
        }
      }

      if (this.$route.query && this.$route.query.anonymous) {
        defaultIsAnonymous = this.$route.query.anonymous === 'true';
        hasAnonymousQueryParam = true;
      }

      if (!this.communeNeedsReset && this.booking.bIObjects && this.booking.bIObjects.length > 0) {
        const initialBIObjectData = this.booking.bIObjects[0].bIObjectData;
        shouldLoadQueryParams =
          (hasGuestTypeQueryParams &&
            (initialBIObjectData.guestType !== defaultGuestType ||
              initialBIObjectData.subGuestType !== defaultSubGuestType ||
              initialBIObjectData.isAnnual !== defaultIsAnnual)) ||
          (hasAnonymousQueryParam && initialBIObjectData.isAnonymous !== defaultIsAnonymous);
      }

      this.resetBooking(shouldLoadQueryParams);

      if (this.booking.bIObjects.length == 0) {
        this.addBIObject(defaultGuestType, defaultIsAnonymous);
        if (defaultIsAnonymous) {
          this.booking.bIObjects[0].bIObjectData.personCount = 1;
        }
        this.booking.bIObjects[0].bIObjectData.subGuestType = defaultSubGuestType;
        this.adjustInitialDatesForGuestType(this.booking.bIObjects[0]);
      } else if (this.communeNeedsReset || shouldLoadQueryParams) {
        if (defaultGuestType != null) {
          this.booking.bIObjects[0].bIObjectData.guestType = defaultGuestType;
        }
        if (defaultIsAnonymous !== null && this.booking.bIObjects[0].bIObjectData.guestType === GuestTypesEnum.day) {
          this.booking.bIObjects[0].bIObjectData.isAnonymous = defaultIsAnonymous;
        }
        this.booking.bIObjects[0].bIObjectData.subGuestType = defaultSubGuestType;
        this.booking.bIObjects[0].bIObjectData.isAnnual = defaultIsAnnual;
        this.adjustInitialDatesForGuestType(this.booking.bIObjects[0]);
      }
      this.resetGuestTypeRadioOption(this.booking.bIObjects[0]);
      this.proceedIsLoading = false;
      this.canUpdatePrices = true;
      this.$nextTick(() => this.onUpdatePrices());
    }
  }

  @Watch('booking', { deep: true })
  public async onBookingChange(booking: Booking) {
    if (!this.commune || !this.booking.communeId) {
      return;
    }
    this.setCurrentBooking(booking);
  }

  private resetGuestTypeRadioOption(bIObject: BIObject) {
    bIObject.additionalGuestTypeFields.guestTypeRadioOptionValue = findGuestTypeOptionRadioValue(bIObject, this.communeGuestTypeOptions);
  }

  private findCommuneGuestTypeOption(guestType: GuestType, subGuestType: string): CommuneGuestTypeOption | undefined {
    return this.communeGuestTypeOptions.find(
      option => !option.isAnnual && option.guestType === guestType && option.subGuestType === subGuestType
    );
  }

  private hasValidGuestTypeOption(bIObject: BIObject): boolean {
    return this.communeGuestTypeOptions.some(
      option =>
        option.guestType === bIObject.bIObjectData.guestType &&
        option.subGuestType === bIObject.bIObjectData.subGuestType &&
        option.isAnnual === bIObject.bIObjectData.isAnnual
    );
  }

  private adjustInitialDatesForGuestType(bIObject: BIObject): void {
    const stayBegin = momentStartDay(moment());
    bIObject.bIObjectData.stayBegin = stayBegin;
    if (bIObject.bIObjectData.guestType === GuestTypesEnum.overnight) {
      bIObject.bIObjectData.stayEnd = momentEndDay(stayBegin.clone()).add(1, 'day');
    } else {
      bIObject.bIObjectData.stayEnd = momentEndDay(stayBegin.clone());
    }
  }

  public async onUpdatePrices(doRetry: boolean = false) {
    if (this.booking.isDonation() || !this.canUpdatePrices || this.communeIsLoading) {
      return;
    }
    if (this.booking.bIObjects.some(bIObject => !this.hasValidGuestTypeOption(bIObject))) {
      console.warn('Skipping price calculation for an unsupported guest type option.');
      return;
    }
    if (doRetry && this.priceProjectionIsLoading) {
      this.doPriceProjectionRetry = true;
    }
    if (this.booking.communeId === 0 || this.priceProjectionIsLoading) {
      return;
    }

    this.priceProjectionIsLoading = true;
    try {
      if (this.booking.bIObjects.length > 0) {
        const priceProjection = await this.fetchBookingPrice({ booking: this.booking, manuallyDefinedSpecialConditions: this.manuallyDefinedSpecialConditions });
        this.priceProjection = { ...priceProjection };
        this.setCurrentPriceProjection({ ...priceProjection });
      }
    } catch (e) {
      console.error('Failed to calculate price', e);
      this.$store.commit('openOverlay', {
        overlayName: 'Info',
        overlayData: {
          title: i18next.t('transactionOverview.transaction.cancelDialog.error.title'),
          message: i18next.t('transactionOverview.transaction.cancelDialog.error.body'),
        },
      });
    } finally {
      this.priceProjectionIsLoading = false;
      if (this.doPriceProjectionRetry) {
        this.doPriceProjectionRetry = false;
        this.onUpdatePrices();
      }
    }
  }

  public proceed(): void {
    this.$trackEvent('booking', 'proceed');
    if (this.booking.bIObjects.length === 0) return;

    this.proceedIsLoading = true;
    this.validateBIObjects();
    if (this.areBIObjectsErroneous()) {
      setTimeout(() => {
        const element = document.querySelector('.has-errors');
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
          });
        }
        this.proceedIsLoading = false;
      }, 100);
    } else {
      let isDonation = false;
      if (this.booking.isDonation()) {
        isDonation = true;
      } else {
        this.booking.bIObjects.forEach(bIObject => {
          if (this.commune && bIObject.bIObjectData.guestType !== GuestTypesEnum.donation) {
            this.checkIfIsAnnualCandidate(this.commune, bIObject);
          }
        });
      }
      const booking = this.booking;
      const manuallyDefinedSpecialConditions = this.manuallyDefinedSpecialConditions;
      if (isDonation) {
        this.donationRequest({ booking }).then((transaction: any) => {
          this.$trackEvent('booking', 'proceed-success');
          if (transaction && transaction.orderId) {
            // set the priceProjection to donation to render the checkoutView correctly
            this.setCurrentPriceProjection({donations: [{price: transaction.price}], price: transaction.price});
            this.setCurrentOrderId(transaction.orderId);
            this.goToPayment(transaction.orderId);
          }
        });
      } else {
        this.bookingRequest({ booking, manuallyDefinedSpecialConditions }).then((transaction: any) => {
          this.$trackEvent('booking', 'proceed-success');
          if (transaction && transaction.orderId) {
            this.setCurrentOrderId(transaction.orderId);
            this.goToPayment(transaction.orderId);
          }
        });
      }
    }
  }

  public areBIObjectsErroneous(): boolean {
    let result = false;
    this.booking.bIObjects.forEach(t => {
      if (!result) {
        result = t.bIObjectData.errors.length > 0;
      }
    });
    return result;
  }

  public validateBIObjects(): void {
    let difAccCounter = 0;
    let lastAccID = -1;
    let foreignersCounter = 0;

    this.booking.bIObjects.forEach((t) => {
        if (t.bIObjectData.accommodation !== null && t.bIObjectData.accommodation !== undefined && t.bIObjectData.accommodation != '' && (t.bIObjectData.accommodation as any).id != undefined) {
          let accProj = t.bIObjectData.accommodation as AccommodationProjection;
          if (accProj.id != lastAccID) {
            difAccCounter++;
            lastAccID = accProj.id!;
          }
        }
        if (t.bIObjectData.nationality != 'DE') {
          foreignersCounter++;
        }
        t.bIObjectData.validate(getMandatoryFieldsToValidate(t, this.additionalMandatoryFields))
        // t.validate(this.additionalMandatoryFields)
        if (foreignersCounter > 0 && difAccCounter > 1) {
          t.bIObjectData.addError('accommodation', 'isEmpty', i18next.t('taxcard.validation.accommodation.hasMultipleWithForeigner'));
          //Multiple bookings including any non german citizens can only be done for the same accommodation, either change the accommodations or buy the cards with separate bookings.
        }
      }
    );
  }

  public addBIObjectExplicit() {
    this.$trackEvent('booking', 'add-taxcard');
    let defaultGuestType = null;
    let defaultIsAnonymous = null;
    if (this.booking.bIObjects.length == 0) {

      const communeWebConfig = this.commune && this.commune.webConfiguration;
      if (communeWebConfig) {
        defaultGuestType = communeWebConfig.defaultGuestType;
        defaultIsAnonymous = communeWebConfig.defaultIsAnonymous;
      }
    }

    this.addBIObject(defaultGuestType, defaultIsAnonymous);
  }

  public addBIObject(defaultGuestType: GuestType | null = null, defaultIsAnonymous: boolean | null = null): void {
    this.validateBIObjects();
    if (this.areBIObjectsErroneous()) {
      this.scrollToBIObjectError();
      return;
    }

    this.booking.bIObjects.forEach(bIObject => {
      if (this.commune) {
        this.checkIfIsAnnualCandidate(this.commune, bIObject);
      }
    });

    const bIObject = this.createNewBIObject(defaultGuestType, defaultIsAnonymous);
    this.booking.addBIObject(bIObject);
    this.resetGuestTypeRadioOption(bIObject);
    this.bIObjectCount += 1;
    this.openBIObjectIndex = null;
    this.$forceUpdate();
    this.$nextTick(() => {
      this.openBIObjectIndex = this.booking.bIObjects.length - 1;
      window.scrollTo(0, 0);
    });
  }

  /**
   * Scrolls to first visible error on the page
   */
  public scrollToBIObjectError() {
    setTimeout(() => {
      const element = document.querySelector('.has-errors');
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
        });
      }
    }, 100);
  }

  public async onCommuneChange(id: number) {
    try {
      this.canUpdatePrices = false;
      await this.loadAndSetCommune(id);
      this.resetBooking();
      // this.resetCommuneRelativeData();
      this.resetGuestTypeRadioOption(this.booking.bIObjects[0]);
      this.canUpdatePrices = true;
      this.$nextTick(() => this.onUpdatePrices());
    } catch (error) {}
  }

  public onRemoveBIObject(index: number): void {
    // if (this.booking.isAnonymous) {
    //   this.booking.isAnonymous = false;
    // }
    this.booking.bIObjects.splice(index, 1);
    this.bIObjectCount -= 1;
    this.openBIObjectIndex = null;
    this.resetAccommodationRestriction();
    this.onUpdatePrices();
    this.$forceUpdate();
  }

  private resetAccommodationRestriction() {
    if (this.bIObjectCount > 0) return;

    this.booking.strictAccommodation = false;
  }

  public onToggleOpen(index: number): void {
    this.onUpdatePrices();
    this.openBIObjectIndex = index;
  }

  public get checkoutButtonPrice(): number {
    if (this.booking.isDonation()) {
      return 0;
    }
    return this.priceProjection.price;
  } 

  public get additionalMandatoryFields(): AdditionalMandatoryField[] {
    const commune = this.commune;
    return (commune && commune.bookingMandatoryFields) || [];
  }

  public goToPayment(orderId: string) {
    this.setCurrentBookingToCheckoutView(this.booking);
    this.$router.push({ name: 'checkout' });
  }

  public async loadAndSetCommune(id: number): Promise<void> {
    this.communeIsLoading = true;
    if (id !== parseInt(this.$route.params.communeId, 10)) {
      await this.$router.push({ name: 'booking', params: { communeId: id.toString() } });
    }
    try {
      this.commune = await this.fetchCommune(this.$route.params.communeId);

      /**
       * Create options for Guesttype Selector
       */
      if (this.commune) {
        this.communeGuestTypeOptions = [];
        if (this.commune.overnightGuests) {
          this.communeGuestTypeOptions.push(new CommuneGuestTypeOption(GuestTypesEnum.overnight, 'booking.guestType.overnight.label', false, ''));
        }
        if (this.commune.dayTrippers) {
          let label = 'booking.guestType.day.label';
          if (this.commune.id === 1801) {
            label = 'booking.cuxhaven.guestType.day.label';
          }
          this.communeGuestTypeOptions.push(new CommuneGuestTypeOption(GuestTypesEnum.day, label, false, ''));
        }
        if (this.commune.isAnnualTicketActive) {
          this.communeGuestTypeOptions.push(new CommuneGuestTypeOption(GuestTypesEnum.overnight, 'booking.annualCard.label', true, ''));
        }
        if (this.commune.hasDonations) {
          this.communeGuestTypeOptions.push(new CommuneGuestTypeOption(GuestTypesEnum.donation, 'booking.donation.label', false, ''));
        }

        if (this.commune.additionalGuestTypes && this.commune.additionalGuestTypes.length > 0) {
          const additionalGuestTypes = this.commune.additionalGuestTypes;
          for (let ind1 = 0; ind1 < additionalGuestTypes.length; ind1++) {
            const additionalGuestType = additionalGuestTypes[ind1];
            const additionalGuestTypeDivided = additionalGuestType.split('#');
            let finalGuestTypeString = additionalGuestTypeDivided[0];
            let finalGuestType = GuestTypesEnum.overnight;
            if (GuestTypesEnum.hasOwnProperty(finalGuestTypeString)) {
              finalGuestType = GuestTypesEnum[finalGuestTypeString];
            }
            let finalSubGuestType = '';
            let finalLabelString = `booking.guestType.${finalGuestType}.label`;
            if (additionalGuestTypeDivided.length > 1) {
              finalSubGuestType = additionalGuestTypeDivided[1];
              finalLabelString = `booking.guestType.${finalGuestType}.${finalSubGuestType}.label`;
            }
            this.communeGuestTypeOptions.push(new CommuneGuestTypeOption(finalGuestType, finalLabelString, false, finalSubGuestType));
          }
        }
      }
      // console.log("GuestTypeOptions", this.communeGuestTypeOptions) ;

      const newCommuneId = parseInt(this.$route.params.communeId, 10);
      this.communeNeedsReset = newCommuneId !== this.booking.communeId;
      this.booking.communeId = newCommuneId;
    } catch (e) {
      console.error(`Failed to fetch commune with id '${id}.`, e);
      throw e;
    } finally {
      this.communeIsLoading = false;
    }
  }

  public resetCommuneRelativeData() {
    this.booking.bIObjects.forEach(t => {
      t.bIObjectData.accommodation = {};
      t.bIObjectData.option = {};
    });
  }

  public resetBooking(shouldLoadQueryParams:boolean = false) {
    if (this.communeNeedsReset || shouldLoadQueryParams) {
      let guestType: GuestType = GuestTypesEnum.day;
      if (this.commune && this.commune.overnightGuests) {
        guestType = GuestTypesEnum.overnight;
      }
      const newBIObject = new BIObject(new BIObjectData(guestType));
      newBIObject.bIObjectData.isAnonymous = false;
      newBIObject.bIObjectData.personCount = 0;
      this.booking = new Booking((this.commune && this.commune.id) || 0, [newBIObject]);
      const webConfig = this.commune && this.commune.webConfiguration;
      if (webConfig) {
        this.booking.bIObjects[0].bIObjectData.guestType = webConfig.defaultGuestType;
        this.booking.bIObjects[0].bIObjectData.subGuestType = webConfig.defaultSubGuestType;
        this.booking.bIObjects[0].bIObjectData.isAnonymous = webConfig.defaultIsAnonymous;
        this.booking.bIObjects[0].bIObjectData.personCount = webConfig.defaultIsAnonymous ? 1 : 0;
        this.toggleDiscountsLoading = !this.toggleDiscountsLoading;
        // this.booking.bIObjects = this.booking.bIObjects.map((t) => {
        //   t.guestType = webConfig.defaultGuestType;
        //   t.isAnonymous = webConfig.defaultIsAnonymous;
        //   t.personCount = webConfig.defaultIsAnonymous ? 1 : 0;
        //   return t;
        // });
      }
    }
  }

  createNewBIObject(defaultGuestType: GuestType | null = null, defaultIsAnonymous: boolean | null = null): BIObject {
    if (!this.commune) {
      throw Error('Booking::createNewBIObject - No Commune available');
    }

    const bIObject = this.createBIObjectFromLastBIObject() || new BIObject();

    if (!bIObject.bIObjectData.guestType) {
      bIObject.bIObjectData.guestType = this.commune.overnightGuests ? GuestTypesEnum.overnight : GuestTypesEnum.day;
    }

    if (defaultGuestType) {
      bIObject.bIObjectData.guestType = defaultGuestType;
    }
    if (defaultIsAnonymous !== null && bIObject.bIObjectData.guestType === GuestTypesEnum.day && !this.isLoggedIn) {
      bIObject.bIObjectData.isAnonymous = defaultIsAnonymous;
      if (defaultIsAnonymous) {
        bIObject.bIObjectData.personCount = 1;
      }
    }

    if (!bIObject.bIObjectData.stayBegin) {
      bIObject.bIObjectData.stayBegin = momentStartDay(moment());
    }

    if (!bIObject.bIObjectData.stayEnd) {
      bIObject.bIObjectData.stayEnd = bIObject.bIObjectData.guestType === GuestTypesEnum.overnight ? momentEndDay(moment()).add(1, 'day') : momentEndDay(moment());
    }

    return bIObject;
  }

  /**
   * create a fresh BIObject and copy certain values from the first BIObject in the current booking.
   * copied attributes:
   *  Tagesgast oder Übernachtungsgast
   *  Strasse & Hausnummer
   *  PLZ
   *  Wohnort
   *  Land
   *  Anreise
   *  Abreise
   *  Wohnort (bereits vorhanden)
   */
  createBIObjectFromLastBIObject(): BIObject | undefined {
    const bIObjects = this.booking.bIObjects;
    if (!bIObjects || bIObjects.length === 0) return;

    const bIObject = new BIObject();
    const originBIObject = bIObjects[bIObjects.length - 1];

    if (originBIObject.bIObjectData.addressStreetAndNumber) {
      bIObject.bIObjectData.addressStreetAndNumber = originBIObject.bIObjectData.addressStreetAndNumber;
    }

    if (originBIObject.bIObjectData.addressZipCode) {
      bIObject.bIObjectData.addressZipCode = originBIObject.bIObjectData.addressZipCode;
    }

    if (originBIObject.bIObjectData.addressCity) {
      bIObject.bIObjectData.addressCity = originBIObject.bIObjectData.addressCity;
    }

    if (originBIObject.bIObjectData.addressCountry) {
      bIObject.bIObjectData.addressCountry = originBIObject.bIObjectData.addressCountry;
    }

    if (originBIObject.bIObjectData.nationality) {
      bIObject.bIObjectData.nationality = originBIObject.bIObjectData.nationality;
    }    

    if (originBIObject.bIObjectData.guestType) {
      bIObject.bIObjectData.guestType = originBIObject.bIObjectData.guestType;
    }

    if (originBIObject.bIObjectData.subGuestType) {
      bIObject.bIObjectData.subGuestType = originBIObject.bIObjectData.subGuestType;
    }    

    if (originBIObject.bIObjectData.accommodation) {
      bIObject.bIObjectData.accommodation = { ...originBIObject.bIObjectData.accommodation };
    }

    if (originBIObject.bIObjectData.accommodationsProvidersBookingNo) {
      bIObject.bIObjectData.accommodationsProvidersBookingNo = originBIObject.bIObjectData.accommodationsProvidersBookingNo;
    }

    if (originBIObject.bIObjectData.stayBegin && !originBIObject.bIObjectData.isAnnual) {
      bIObject.bIObjectData.stayBegin = moment(originBIObject.bIObjectData.stayBegin);
    }

    if (originBIObject.bIObjectData.stayEnd && !originBIObject.bIObjectData.isAnnual) {
      bIObject.bIObjectData.stayEnd = moment(originBIObject.bIObjectData.stayEnd);
    }

    return bIObject;
  }

  public async onScanned(accommodation: AccommodationProjection): Promise<void> {
    if (!accommodation.communeId) {
      return;
    }
    await this.loadAndSetCommune(accommodation.communeId);
    const originalGuestType = 
    this.resetBooking();
    if (!this.commune || !this.commune.overnightGuests) {
      return;
    }
    this.booking.strictAccommodation = this.commune.strictAccommodationSelection;
    this.booking.bIObjects[0].bIObjectData.guestType = GuestTypesEnum.overnight;
    this.booking.bIObjects[0].bIObjectData.isAnonymous = false;
    this.booking.bIObjects[0].bIObjectData.accommodation = accommodation;
    this.onBookingChange(this.booking);
    this.resetGuestTypeRadioOption(this.booking.bIObjects[0]);
  }

  public onAnonymousChange(isAnonymous: boolean, bIObject: BIObject): void {
    const newBIObject = new BIObject(new BIObjectData(bIObject.bIObjectData.guestType));
    newBIObject.bIObjectData.isAnonymous = isAnonymous;
    newBIObject.bIObjectData.personCount = isAnonymous ? 1 : 0;
    newBIObject.bIObjectData.isAnnual = bIObject.bIObjectData.isAnnual;
    newBIObject.bIObjectData.subGuestType = bIObject.bIObjectData.subGuestType;
    this.booking = new Booking((this.commune && this.commune.id) || 0, [newBIObject]);
    this.resetGuestTypeRadioOption(this.booking.bIObjects[0]);
    this.$forceUpdate();
  }

  public onGuestTypeChange(bIObject: BIObject): void {
    if (bIObject.bIObjectData.guestType == GuestTypesEnum.donation) {
      const newBIObject = new BIObject(new BIObjectData(GuestTypesEnum.donation));
      newBIObject.bIObjectData.isAnonymous = false;
      newBIObject.bIObjectData.personCount = 0;
      this.booking = new Booking((this.commune && this.commune.id) || 0, [newBIObject]);
      this.resetGuestTypeRadioOption(this.booking.bIObjects[0]);
      this.$forceUpdate();
    }
  }

  public checkIfIsAnnualCandidate(commune: CommuneProjection, bIObject: BIObject): void {
    if (!this.isLoggedIn) {
      return;
    }
    this.fetchAnnualCandidate({ communeId: commune.id, bIObject }).then((projection: AnnualCandidateProjection) => {
      if (projection.isAvailable && projection.isCandidate) {
        this.$store.commit('openOverlay', {
          overlayName: 'Info',
          overlayData: {
            title: i18next.t('booking.cumulativeCard.granted.dialog.title'),
            message: i18next.t('booking.cumulativeCard.granted.dialog.body'),
          },
        });
      }
    });
  }
}
